import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

import { gql } from '@apollo/client';
import { nullable } from '@infl-ts/util-io-ts';
import { makeDecodedMutation } from '@infl-ts/util-make-apollo-decoded';
import * as t from 'io-ts';
import { RevokeSocialAuthInput, RevokeSocialAuthOutput } from './codecs';
export var useRevokeSocialAuth = makeDecodedMutation(gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    mutation revokeSocialAuthentication($input: RevokeSocialAuthenticationInput!) {\n      revokeSocialAuthentication(input: $input) {\n        ... on RevokeSocialAuthenticationResult {\n          socialAccount {\n            id\n            connected\n\n            ... on Linkedin {\n              expiresAt\n              profileUrl\n            }\n            ... on Twitter {\n              profileUrl\n            }\n            ... on Facebook {\n              profileUrl\n            }\n          }\n        }\n      }\n    }\n  "]))), RevokeSocialAuthOutput, RevokeSocialAuthInput);
export var useSetSocialVisibility = makeDecodedMutation(gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    mutation SetSocialVisibility($input: SetSocialVisibilityInput!) {\n      setSocialVisibility(input: $input) {\n        ... on SetSocialVisibilityErrors {\n          errors {\n            ... on Error {\n              message\n            }\n          }\n        }\n        ... on SetSocialVisibilityResult {\n          authVisibility {\n            visible\n          }\n        }\n      }\n    }\n  "]))), t.type({
  setSocialVisibility: t.union([t.type({
    __typename: t.literal('SetSocialVisibilityErrors'),
    errors: t.array(t.type({
      message: t.string
    }))
  }), t.type({
    __typename: t.literal('SetSocialVisibilityResult'),
    authVisibility: nullable(t.type({
      visible: t["boolean"]
    }))
  })])
}), t.type({
  input: t.type({
    id: t.string,
    visible: t["boolean"]
  })
}));